import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import { AsrProviderTranscriptService } from 'app/API/custom/asr-execution/AsrProviderTranscriptService';
import type { asrProxyKeys } from 'app/queries/asrProxy/asrProxyKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof asrProxyKeys.providerTranscription>>;

export const createFetchAsrProviderTranscriptionQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ provider, providerTranscriptId }], signal }: TParams) =>
    call(
      () => cancelOnSignal(AsrProviderTranscriptService.retrieveTranscription(provider, providerTranscriptId), signal),
      {
        dontRedirectOnError: true,
      },
    );
